import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiService } from "./api";

export interface KuaishouWebAuthorizeUrlResponse {
  authorize_url: string;
}

class KuaishouWebAuthorizeUrlData {
  @Required("Authorize url cannot be empty")
  @IsString("Authorize url must be a string")
  authorizeUrl: string;
}

const transformAndValidateData = (
  response: KuaishouWebAuthorizeUrlResponse
): KuaishouWebAuthorizeUrlData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KuaishouWebAuthorizeUrlData);
  } catch (error) {
    console.error("Kuaishou web authorize url data validation failed:", error.message);
    throw error;
  }
};

// 快手授权
export const kuaishouWebAuthorizeUrl = async (redirectUri: string) => {
  const res = await api.post<KuaishouWebAuthorizeUrlResponse>('/kuaishou/web/authorize-url', {
    frontend_redirect_uri: redirectUri,
  });
  return transformAndValidateData(res.data);
};
